export function getStringWithUpperFirstChar (string) {
    if(string) {
        const formated_string = string.slice(0,1).toUpperCase() + string.slice(1, string.length )
        return formated_string  
    }
}
